<div class="tableContainer">
    <div class="tableContainer__scroll">
        <div class="tableContainer__content" data-table></div>
    </div>
    <div class="tableContainer__fadeElement"></div>
</div>
